import { render, staticRenderFns } from "./InformacionPaciente.vue?vue&type=template&id=fa5e28d6&scoped=true"
import script from "./InformacionPaciente.vue?vue&type=script&lang=ts"
export * from "./InformacionPaciente.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5e28d6",
  null
  
)

export default component.exports